export class IssueGitlab {
     title: string = "";
     labels: string = "From Front";
     nom: string = "";
     description: string = "";
}